export { default as CoreNavigationHistoryDirective } from './History';
